<script setup lang="ts">
import { cn } from '@/lib/utils'
import { TabsTrigger, type TabsTriggerProps, useForwardProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<TabsTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <TabsTrigger
    v-bind="forwardedProps"
    :class="
      cn(
        'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-gray-100 bg-white px-3 py-1.5 font-semibold transition-all hover:bg-gray-50 focus-visible:outline-none data-[state=active]:border-blue-600 data-[state=active]:bg-blue-600 data-[state=active]:text-white [&_svg]:shrink-0',
        props.class
      )
    "
  >
    <slot />
  </TabsTrigger>
</template>
